import http from 'utils/http';
import { BusinessProfileResponse } from 'apis/business/types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { AgencyPerformanceResponse, UsageAnalyticsResponse, UsageBreakDownResponse } from './types';
import {
  getAgencyPerformanceUrl,
  getAgencyUsageAnalyticsUrl,
  getAgencyUsageBreakdownUrl,
  getBusinessesUrl,
  getBusinessUrl
} from './apiUrls';

export function getBusinesses(
  params?: Record<string, any>
): Promise<{ data: BusinessProfileResponse[]; meta: MetaApiResponse }> {
  return http.get(getBusinessesUrl(), params);
}

export function getDeleteBusiness(id: number): Promise<{ data: BusinessProfileResponse[] }> {
  return http.delete(getBusinessUrl(id));
}

export function createBusiness(payload: FormData): Promise<BusinessProfileResponse> {
  return http.post(getBusinessesUrl(), payload);
}

export function updateBusiness(id: number, payload: any): Promise<BusinessProfileResponse> {
  return http.put(getBusinessUrl(id), payload);
}

export function getAgencyPerformance(): Promise<AgencyPerformanceResponse> {
  return http.get(getAgencyPerformanceUrl());
}

export function getAgencyUsageAnalytics(params?: Record<string, any>): Promise<UsageAnalyticsResponse> {
  return http.get(getAgencyUsageAnalyticsUrl(), params);
}

export function getAgencyUsageBreakdown(
  params?: Record<string, any>
): Promise<{ data: UsageBreakDownResponse[]; meta: MetaApiResponse }> {
  return http.get(getAgencyUsageBreakdownUrl(), params);
}
